import { someConversationsSelected } from './getItemsOrConversationsSelectedText.locstring.json';
import { everythingSelected } from 'owa-locstrings/lib/strings/everythingselected.locstring.json';
import { everythingSelectedOther } from 'owa-locstrings/lib/strings/everythingselectedother.locstring.json';
import { everythingSelectedFocused } from 'owa-locstrings/lib/strings/everythingselectedfocused.locstring.json';
import { someItemsSelected } from 'owa-locstrings/lib/strings/someitemsselected.locstring.json';
import loc, { format } from 'owa-localize';

import listViewStore from '../store/Store';
import getIsEverythingSelectedInTable from './getIsEverythingSelectedInTable';
import isItemPartOperation from './isItemPartOperation';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import getFocusedFilterForTable from '../utils/getFocusedFilterForTable';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import { getInboxClassificationFilterForTable } from 'owa-mail-list-store';
import isInboxPlusEnabled from 'owa-mail-inbox-plus-store/lib/selectors/isInboxPlusEnabled';
import getInboxPlusPivotDisplayProperties from 'owa-mail-inbox-plus-store/lib/selectors/getInboxPlusPivotDisplayProperties';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

export default function getItemsOrConversationsSelectedText(tableViewId: string): string {
    const tableView = listViewStore.tableViews.get(tableViewId);
    const focusedFilter = getFocusedFilterForTable(tableView);
    const inboxClassificationFilter = getInboxClassificationFilterForTable(tableViewId);

    // User is in select all mode
    if (getIsEverythingSelectedInTable(tableView)) {
        // Some items are deselected, return total item count - number of deselected items
        if (tableView.virutalSelectAllExclusionList.length > 0) {
            return format(
                loc(someItemsSelected),
                tableView.totalRowsInView - tableView.virutalSelectAllExclusionList.length
            );
            // User is in select all mode in focused/other table
        } else if (
            isInboxPlusEnabled() &&
            folderNameToId('inbox') === tableView.tableQuery.folderId
        ) {
            const displayProperties = getInboxPlusPivotDisplayProperties(inboxClassificationFilter);
            //TODO: VSO 40597 -- Inbox Plus Loc strings
            return format('Everything in {0} is selected', displayProperties.displayText);
        } else if (focusedFilter !== FocusedViewFilter.None) {
            return focusedFilter === FocusedViewFilter.Focused
                ? loc(everythingSelectedFocused)
                : loc(everythingSelectedOther);
        } else {
            // Everything in folder is selected
            return loc(everythingSelected);
        }
    } else {
        // User has selected a specific number of items or item parts
        const selectedString =
            tableView.tableQuery.listViewType == ReactListViewType.Message || isItemPartOperation()
                ? loc(someItemsSelected)
                : loc(someConversationsSelected);
        return format(
            selectedString,
            isItemPartOperation()
                ? listViewStore.expandedConversationViewState.selectedNodeIds.length
                : tableView.selectedRowKeys.size
        );
    }
}
